import { defaultFilters, defaultPaginate } from './state';

/**
 * Reinicia el filtro de busqueda de productos.
 *
 * @param {*} state.
 */
export function resetFilters(state) {
    state.filters = { ...defaultFilters() };
}

/**
 * Actualiza el listado de los fabricantes.
 *
 * @param {*} state.
 * @param {*} manufacturers.
 */
export function setManufacturers(state, manufacturers) {
    state.manufacturers = manufacturers;
}


/**
 * Actualiza el producto seleccionado a agregad.
 *
 * @param {*} state.
 * @param {*} productSelected.
 */
export function setProductSelected(state, productSelected) {
    state.productSelected = productSelected;
}


/**
 * Actualiza el listado de productos que se pueden asignar.
 *
 * @param {*} state.
 * @param {*} products.
 */
export function setProducts(state, products) {
    state.products = products;
}


/**
 * Actualiza el listado de productos que se pueden asignar.
 *
 * @param {*} state.
 * @param {*} products.
 */
export function setPaginationData(state, pagination) {
    state.paginate.page = pagination.current_page;
    state.paginate.per_page = pagination.per_page;
    state.paginate.total = pagination.total;
}

/**
 * Actualiza el listado de productos que se pueden asignar.
 *
 * @param {*} state.
 * @param {*} products.
 */
export function resetPaginationData(state) {
    state.paginate = { ...defaultPaginate() }
}

/**
 * Actualiza la pagina a visualizar.
 *
 * @param {*} state.
 * @param {*} products.
 */
export function setPage(state, page) {
    state.paginate.page = page;
}

/**
 * Actualiza limite de registros a ver por pagina.
 *
 * @param {*} state.
 * @param {*} products.
 */
export function setPerPage(state, perPage) {
    state.paginate.per_page = perPage;
}
